import IConstraints from '../../../types/IContraints';
import { isFile } from '../../../lib/typeGuards';
import { ValidationRule } from './validate';
import { ImageMetaData } from './validateImage';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export function useValdidationRules(constraints: IConstraints): ValidationRule[] {
  const { t } = useSonTranslation('FileUpload');
  const validationRules: ValidationRule[] = [];

  if (constraints.minFileSizeInBytes) {
    validationRules.push({
      expression: (obj: File | ImageMetaData) => {
        return isFile(obj) && constraints.minFileSizeInBytes ? obj.size < constraints.minFileSizeInBytes : false;
      },
      getErrorMessage: (obj) => {
        if (constraints.minFileSizeInBytes === 1) {
          return t(`validationErrorMessages.minFileSizeZero`, {
            fileName: isFile(obj) ? obj.name : obj.fileName,
          });
        }
        return t(`validationErrorMessages.minFileSizeInBytes`, {
          fileName: isFile(obj) ? obj.name : obj.fileName,
          minSize: (constraints.minFileSizeInBytes as number) / 1024,
        });
      },
    });
  }

  if (constraints.maxFileSizeInBytes) {
    validationRules.push({
      expression: (obj: File | ImageMetaData) => {
        return isFile(obj) && constraints.maxFileSizeInBytes ? obj.size > constraints.maxFileSizeInBytes : false;
      },
      getErrorMessage: (obj) => {
        const maxSize = Math.round((constraints.maxFileSizeInBytes || 0) / (1024 * 1024));
        return t(`validationErrorMessages.maxFileSizeInBytes`, {
          fileName: isFile(obj) ? obj.name : obj.fileName,
          maxSize,
        });
      },
    });
  }

  if (constraints.minWidth) {
    validationRules.push({
      expression: (obj: File | ImageMetaData) => {
        return !isFile(obj) && constraints.minWidth ? obj.width < constraints.minWidth : false;
      },
      getErrorMessage: obj =>
        t(`validationErrorMessages.minWidth`, {
          fileName: isFile(obj) ? obj.name : obj.fileName,
          minWidth: constraints.minWidth || '',
        }),
    });
  }

  if (constraints.maxWidth) {
    validationRules.push({
      expression: (obj: File | ImageMetaData) => {
        return !isFile(obj) && constraints.maxWidth ? obj.width > constraints.maxWidth : false;
      },
      getErrorMessage: obj =>
        t(`validationErrorMessages.maxWidth`, {
          fileName: isFile(obj) ? obj.name : obj.fileName,
          maxWidth: constraints.maxWidth || '',
        }),
    });
  }
  if (constraints.minHeight) {
    validationRules.push({
      expression: (obj: File | ImageMetaData) => {
        return !isFile(obj) && constraints.minHeight ? obj.height < constraints.minHeight : false;
      },
      getErrorMessage: obj =>
        t(`validationErrorMessages.minHeight`, {
          fileName: isFile(obj) ? obj.name : obj.fileName,
          minHeight: constraints.minHeight || '',
        }),
    });
  }

  if (constraints.maxHeight) {
    validationRules.push({
      expression: (obj: File | ImageMetaData) => {
        return !isFile(obj) && constraints.maxHeight ? obj.height > constraints.maxHeight : false;
      },
      getErrorMessage: obj =>
        t(`validationErrorMessages.maxHeight`, {
          fileName: isFile(obj) ? obj.name : obj.fileName,
          maxHeight: constraints.maxHeight || '',
        }),
    });
  }
  return validationRules;
}
